import React from "react";
import { Modal } from 'antd';

// Store
import {store} from '../../store/store';

// Utils
import {FieldTranslation} from "../../utils/functions";


export function SUCCESS_MODAL(message: string) {
  Modal.success({
    title: <FieldTranslation field={'actionPerformedSuccessfully'} />,
    content: message,
    keyboard: false,
    maskClosable: false,
  });
}
export function SUCCESS_MODAL_ON_OK(message: string, onOkFunction: () => void) {
  Modal.success({
    title: <FieldTranslation field={'actionPerformedSuccessfully'} />,
    content: message,
    keyboard: false,
    maskClosable: false,
    onOk () {
      store.dispatch(onOkFunction)
    }
  });
}
export function ERROR_MODAL(message: string) {
  Modal.error({
    title: <FieldTranslation field={'errorPerformingTheAction'} />,
    content: message,
    keyboard: false,
    maskClosable: false
  });
}

export function WARNING_MODAL(message: string) {
  Modal.warning({
    title: <FieldTranslation field={'warning'} />,
    content: message,
    keyboard: false,
    maskClosable: false
  });
}